module.exports = __webpack_public_path__ + "img/attribute_mark_3_off.2d074ac.png";